import { Grid } from 'antd';
import React from 'react';

function UseBreakPoint({ children }) {
  return children({ ...Grid.useBreakpoint() });
}

export default React.memo(UseBreakPoint);
